import './App.css';
import Home from './components/Home';
import AppNavbar from './components/Navbar';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ServiceDetail from './components/ServiceDetail';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="App">
        <AppNavbar></AppNavbar>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/:serviceId" element={<ServiceDetail />} />
        </Routes>
        <Footer></Footer>
      </div>
    </Router>
  );
}

export default App;
